import { SmartSelector } from "@/overlay/components/CommonParts/SmartSelector";
import { createDurationOptions } from "@/time";
import React from "react";

enum EarthquakeTimeInterval {
  PT1H = "PT1H",
  PT3H = "PT3H",
  PT6H = "PT6H",
  PT12H = "PT12H",
  P1D = "P1D",
  P2D = "P2D",
  P3D = "P3D",
}

export const earthquakeTimeDurations = createDurationOptions(EarthquakeTimeInterval);

type EarthquakeTimeDurationSelectorProps = {
  onSelect: (parameter: any) => void;
  selectedItemKey: string;
};

export const EarthquakeTimeDurationSelector = ({ onSelect, selectedItemKey }: EarthquakeTimeDurationSelectorProps) => {
  const activeParameters = React.useMemo(
    () =>
      earthquakeTimeDurations.map((o) => {
        return { label: o.displayName(), key: o.isoFormatted, value: o.isoFormatted };
      }),
    [],
  );

  return <SmartSelector items={activeParameters} selectedItemKey={selectedItemKey} onSelect={onSelect} />;
};
